import "./styles.scss";

import { navigate } from "gatsby";
import React, { useState } from "react";

import Categories from "./components/Categories";

import { usePosts } from "context/posts";

const Input = ({ placeholder, onSubmit, onChange }) => {
  return (
    <div className="blog-main__filters__input">
      <input
        type="text"
        aria-label={placeholder}
        placeholder={placeholder}
        onChange={(e) => onChange(e?.target?.value)}
      />
      <button onClick={onSubmit} aria-label="submit">
        <img
          src={require("assets/icons/arrow-right--new.svg").default}
          alt=""
        />
      </button>
    </div>
  );
};

const Filters = ({ category, hidePaginationInput }) => {
  const { categories } = usePosts();

  const [page_number, setPageNumber] = useState(null);
  const [search, setSearch] = useState(null);

  const numberPageHandler = () => {
    let page = page_number;
    if (page === "0" || page === "1") {
      page = null;
    }

    navigate(`/blog${!!page ? `/page/${page}/` : ""}`);
  };

  const searchHandler = () => {
    navigate(`/wyszukiwarka?query=${search}`);
  };

  const current_category = categories?.find((item) => item?.slug === category);

  return (
    <div className="blog-main__filters">
      <div className="row">
        <div className="col-lg-4 col-sm-6">
          <Input
            placeholder="Jakie zagadnienie Cię interesuje?"
            onSubmit={searchHandler}
            onChange={setSearch}
          />
        </div>
        <div className="col-lg-4 col-sm-6">
          {!!!hidePaginationInput && (
            <Input
              onSubmit={numberPageHandler}
              placeholder="Podaj numer strony i przejdź"
              onChange={setPageNumber}
            />
          )}
        </div>
        <div className="col-lg-4 col-sm-6 d-flex align-items-lg-center justify-content-lg-end">
          <Categories selected={current_category} />
        </div>
      </div>
    </div>
  );
};

export default Filters;
